import { X } from 'lucide-react'

import styles from './InviteResultsPanel.module.scss'

export interface ResultRow {
  label: string
  detail?: string
  kind: 'success' | 'info' | 'error'
}

/**
 * Per-email outcome breakdown for a batch where at least one item didn't succeed: bulk invite (rows
 * from `bulkInviteResultRows`) and "Resend all" (rows from `resendResultRows`). All-success batches
 * toast instead, so neither caller renders this then.
 */
const InviteResultsPanel = ({
  rows,
  onDismiss,
  dismissLabel = 'Dismiss invite results',
}: {
  rows: ResultRow[]
  onDismiss: () => void
  dismissLabel?: string
}) => {
  if (rows.length === 0) return null

  return (
    <div className={styles.panel} data-testid="invite-results-panel" aria-live="polite">
      <div className={styles.rows}>
        {rows.map(({ label, detail, kind }) => (
          <div key={label} className={styles.row}>
            <span className={styles[kind]}>{label}</span>
            {detail && <span className={styles.detail}>{detail}</span>}
          </div>
        ))}
      </div>
      <button type="button" className={styles.dismiss} onClick={onDismiss} aria-label={dismissLabel}>
        <X size={16} />
      </button>
    </div>
  )
}

export default InviteResultsPanel
